import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import { IChannel, IChannelListRequest, ChannelState } from "@/types/channel";
import CustomRequest from "../customRequest";

const actions: ActionTree<ChannelState, RootState> = {
  async get({ commit }, id: number) {
    await CustomRequest.get<IPagination<IChannel>>({
      uri: `/channel/${id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, params: IChannelListRequest) {
    await CustomRequest.get<IPagination<IChannel>>({
      uri: "/channel",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
